import {
  Box,
  BoxProps,
  HStack,
  Skeleton,
  SkeletonText,
} from '@chakra-ui/react';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';

export const Group: React.FC<BoxProps> = ({ ...boxProps }) => {
  return (
    <Card p="6" {...boxProps}>
      <HStack w="full">
        <Skeleton>
          <Box w={8} h={8} />
        </Skeleton>
        <SkeletonText mt="4" noOfLines={2} spacing="3" w="full" />
      </HStack>
    </Card>
  );
};
